var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProxyImg',{attrs:{"img":_vm.data}})}
var staticRenderFns = []

export { render, staticRenderFns }